// extracted by mini-css-extract-plugin
export default {"layout":"Layout_layout__zXAI3","logoContainer":"Layout_logoContainer__FfStP","logoBetaText":"Layout_logoBetaText__0xRBI"};